import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

const getSessionId = () => {
  let sid = sessionStorage.getItem('tracking_session_id');
  if (!sid) {
    sid = crypto.randomUUID();
    sessionStorage.setItem('tracking_session_id', sid);
  }
  return sid;
};

export const usePageTracking = () => {
  useEffect(() => {
    const record = async () => {
      try {
        await supabase.from('page_views').insert({
          page_url: window.location.pathname + window.location.hash,
          referrer: document.referrer || null,
          user_agent: navigator.userAgent,
          session_id: getSessionId(),
        });
      } catch {
        // silently fail
      }
    };
    record();
  }, []);
};
